import { trackCxFoundationsSelfServeTopicCsatClick } from "@faire/web-api--source/events/cxFoundations/click/selfServeTopicCsat";
import { trackCxFoundationsHelpCenterComprehensiveCsatSubmit } from "@faire/web-api--source/events/cxFoundations/submit/helpCenterComprehensiveCsat";

import { Feedback, ICSATContext } from "./types";

/**
 * https://www.faire.com/pete/event/cx_foundations-self_serve_topic_csat-click
 */
export const trackCsatClick = (
  brandOrRetailerToken: string | undefined,
  issue: string,
  feedback: Feedback
) => {
  trackCxFoundationsSelfServeTopicCsatClick(
    issue,
    feedback,
    brandOrRetailerToken ?? ""
  );
};

/**
 * Collect CSAT information with PETE
 *
 * https://www.faire.com/pete/event/cx_foundations-help_center_comprehensive_csat-submit
 */
export const trackCsatSubmit = (
  feedback: Feedback,
  checkedReasons: string[],
  openReason: string,
  context: ICSATContext
) => {
  const brandToken = getToken(context, "b_");
  const retailerToken = getToken(context, "r_");
  trackCxFoundationsHelpCenterComprehensiveCsatSubmit(
    context.issue,
    context.brandOrderToken ?? "",
    String(context.isInstantAnswerAvailable),
    context.suggestedArticles.join(" && "),
    context.lastVisitedArticle,
    feedback,
    checkedReasons.join(" && "),
    openReason.trim(),
    brandToken,
    retailerToken
  );
};

const getToken = (context: ICSATContext, prefix: string) => {
  return context.brandOrRetailerToken?.startsWith(prefix)
    ? context.brandOrRetailerToken
    : "";
};
